import React, { useState } from 'react'
import {toast} from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const SentTransactionItem = () => {

  const params = useParams()
  const token = useSelector((state)=>state.user.token)
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()


  const completeTransaction = ()=>{
    setLoading(true)
    const url = `https://salama-api.onrender.com/transactions/${params.id}/complete`;

    fetch(url, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({}),
    })
      .then(response => {
        if (!response.ok) {
           // Check if the response contains a JSON error message from the server
           return response.json().then(errorData => {
            throw new Error(errorData.message || 'Network response was not ok');
          });
        }
        return response.json();
      })
      .then(data => {
        console.log('Confirmation response:', data);
        setLoading(false)
        navigate('/user')
        toast.success(data.message)
      })
      .catch(error => {
        console.error('Error:', error);
        setLoading(false)
        toast.error(error.message)
      });

  }


  return (
  <div>
    <button disabled={loading} onClick={completeTransaction} className='bg-primary p-4'>{loading ? "loading ..." : "Complete  transaction"}</button>
  </div>
  )
}

export default SentTransactionItem